import { SnSize } from '@lib/common/types';
import { SnPointLike } from '@lib/geo/helpers';
import { SnBadgeConfig } from '@lib/ui/badge';

import { IBaseMarkerOptions } from './base-marker-options';

export interface IMapFontIcon {
  fontIcon: string;
  fontSet: string;
  size?: SnSize;
}

export interface IMapFontIconUnicode {
  fontIconUnicode: string;
  fontSet: string;
}

export interface IMapNameIcon {
  name: string;
}

export interface IMapIconMarkerOptions extends IBaseMarkerOptions {
  scale?: number;
  color?: string;
  anchor?: SnPointLike;
  badge?: SnBadgeConfig;
  url?: string;
  text?: string;
}

export type MapIconMarkerIcon = string | IMapFontIcon | IMapFontIconUnicode;

export type MapMarkerIcon =
  | string
  | (IMapNameIcon & IMapIconMarkerOptions)
  | (IMapFontIcon & IMapIconMarkerOptions)
  | (IMapFontIconUnicode & IMapIconMarkerOptions);

export function handleMapMarkerIconUnion<T extends object, K extends PropertyKey>(
  obj: T,
  key: K,
): obj is T & Record<K, unknown> {
  return key in obj;
}

export function hasIconProperty<T extends MapMarkerIcon, K extends keyof any>(
  icon: T | string,
  prop: K,
): icon is T & Record<K, unknown> {
  if (icon && typeof icon !== 'string' && handleMapMarkerIconUnion(icon, prop)) {
    return true;
  }
}
